import { IApiCompany, IApiCompanyFilterType } from '../../modules/graphql/types/types';
import { debounceTime } from 'rxjs/operators';
import { NotificationsService } from 'src/app/shared/modules/notifications/notifications.service';
import { Component, OnInit, forwardRef, Input, Output, EventEmitter, ViewChild, OnChanges } from '@angular/core';
import { CompanyService } from 'src/app/shared/services';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { unwrapConnection } from '../../rxjs.pipes';
import { AutoCompleteComponent } from '@progress/kendo-angular-dropdowns';
import {
  companies
} from "src/app/shared/helpers/auth-config/companies.config";
@Component({
  selector: 'app-company-select-single-kendo',
  templateUrl: './company-select-single-kendo.component.html',
  styleUrls: ['./company-select-single-kendo.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CompanySelectSingleKendoComponent),
      multi: true
    }
  ]
})
export class CompanySelectSingleKendoComponent implements OnInit, ControlValueAccessor, OnChanges {
  public authConfig = {
    companies
  };
  @ViewChild("autoCompleteCompany", { static: false }) public autoCompleteCompany: AutoCompleteComponent;
  @Input() placeholder = "Search companies";
  @Input() label = "";
  @Input() staticCompany: IApiCompany[];
  @Input() disabled = false;
  @Input() restrictedCompanyId = '';

  @Input() companyId: string = null;
  public companyList: IApiCompany[] = [];

  @Output() selectionChanged = new EventEmitter<IApiCompany | null>();

  public selected: any = null;
  public loading: boolean = false;
  public searchString: string = '';

  @Input() public set company(val: IApiCompany) {
    this.selectCompany(val?.id);
  }

  constructor(
    private companyService: CompanyService,
    private notifications: NotificationsService
  ) { }

  ngOnInit() {
    if (this.companyId) {
      this.companyService.getById(this.companyId).pipe(
        this.notifications.snackbarErrorPipe(`Error loading company: ${this.companyId}`)
      ).subscribe((company) => {
        this.companyList = [company];
        this.selected = company;
      });
    }
    if (this.staticCompany) this.companyList.push(...this.staticCompany);
  }

  public ngOnChanges() {
    if (!this.companyId) {
      this.selected = null;
    }
  }

  public selectCompany(selected: any) {
    const selectedCompany = this.companyList?.find(a => a.id === selected);
    this.selected = selectedCompany;
    this.selectionChanged.emit(selectedCompany);
    this._propagateChange(this.selected);
  }

  public onSearchChange(search: string) {
    this.searchString = search;
    this.companyList = [];
    this.autoCompleteCompany.toggle(false);
    if (search?.length < 3) return;

    const filters = [{
      type: IApiCompanyFilterType.Name,
      value: search
    }, {
      type: IApiCompanyFilterType.ViewOnlyName,
      value: 'true'
    }];

    this.loading = true;
    this.autoCompleteCompany.toggle(false)
    this.companyService.get(filters).pipe(
      debounceTime(800),
      unwrapConnection()
    ).subscribe(results => {
      this.loading = false;
      this.autoCompleteCompany.toggle(true);
      this.companyList = results;
      if(this.companyList?.length){
        this.companyList = this.companyList?.filter(company => company.id !== this.restrictedCompanyId)
      }
    });
  }

  private _propagateChange = (_: any) => { };

  // Control Value accessor members
  public writeValue(value: any): void {
    if (value !== undefined) {
      this.companyId = value;
    }
  }

  public registerOnChange(fn: any): void {
    this._propagateChange = fn;
  }

  public registerOnTouched(fn: any): void { }
  public setDisabledState?(isDisabled: boolean): void { }

  public closed() {
    if (typeof this.selected === "string") this.selectCompany(null);
  }

  public blur() {
    if (typeof this.selected === "string" && (this.selected as string).length < 3) this.selectCompany(null);
  }

}
